import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Palette } from "lucide-react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="px-8 py-4 text-white">
      <div className="flex items-center justify-between gap-18">
        <div className="w-1/3 flex justify-center">
          <Link to="/" className="flex items-center gap-2 font-bold text-xl accent-orange whitespace-nowrap">
            <Palette className="accent-orange" size={28} />
            Galerie Deveau
          </Link>
        </div>
        <button
          className="lg:hidden accent-orange"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
        <ul className="hidden lg:flex w-1/3 justify-center space-x-8 pr-4">
          <li className="relative group">
            <Link to="/" className="inline-block font-bold accent-orange">
              Accueil
              <span className="absolute left-0 bottom-0 h-0.5 w-0 bg-orange-500 transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </li>
          <li className="relative group">
            <Link to="/collection" className="inline-block font-bold accent-orange">
              Collection
              <span className="absolute left-0 bottom-0 h-0.5 w-0 bg-orange-500 transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </li>
          <li className="relative group">
            <Link to="/contact" className="inline-block font-bold accent-orange">
              Contact
              <span className="absolute left-0 bottom-0 h-0.5 w-0 bg-orange-500 transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </li>
        </ul>
      </div>
      {isOpen && (
        <ul className="lg:hidden mt-4 flex flex-col space-y-3">
          <li>
            <Link to="/" onClick={() => setIsOpen(false)} className="block font-bold">
              Accueil
            </Link>
          </li>
          <li>
            <Link to="/collection" onClick={() => setIsOpen(false)} className="block font-bold">
              Collection
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={() => setIsOpen(false)} className="block font-bold">
              Contact
            </Link>
          </li>
        </ul>
      )}
    </nav>
  );
}

